import { Controller } from "react-hook-form";
import { BaseField } from "./BaseField";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { TableNameAutocompleteInput } from "modules/record/shared/components/TableNameAutocompleteInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { getFieldHelperText } from "../../services/fieldHelperText";
import { useTranslation } from "react-i18next";
import { translateMetadataLabel } from "modules/record/shared/services/recordMetadataLabels";

export const TableNameFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    const { t } = useTranslation();
    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={column.default_value || ""}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <TableNameAutocompleteInput
                        value={field.value ?? ""}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                        fieldLabel={translateMetadataLabel(t, column)}
                    />
                )}
            />
        </BaseField>
    );
};
